import "./SleepApnea.module.css";
import ClinicHeader from "@/reusable_sections/Header";
import YourPartnerInLifelongHealth from "./sections/YourPartnerInLifelongHealth";
import TheSleepGap from "./sections/TheSleepGap";
import SecureYourItinerary from "./sections/SecureYourItinerary";
import PatientResources from "@/reusable_sections/Footer";
export default function SleepApneaPage() {
  return <div>
      <ClinicHeader />
      <YourPartnerInLifelongHealth />
      <TheSleepGap />
      <SecureYourItinerary />
      <PatientResources />
    </div>;
}